import { useHandler } from "@redotech/react-util/hook";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const RequireExactMatchInput = memo(function RequireExactMatchInput({
  requireExactMatch,
  onRequireExactMatchChange,
}: {
  requireExactMatch?: boolean;
  onRequireExactMatchChange: (requireExactMatch: boolean) => void;
}) {
  const setRequireExactMatch = useHandler((value: boolean) => {
    onRequireExactMatchChange(value);
  });
  return (
    <Flex w="full">
      <RedoCheckbox
        label="Require exact match"
        setValue={setRequireExactMatch}
        size="xs"
        value={requireExactMatch ?? true} // default to true
      />
    </Flex>
  );
});
